import React from 'react';

function Header() {
  return (
    <nav className="navbar navbar-expand-lg navbar-dark px-4" style={{backgroundColor: '#2e3440'}}>
      {/* <a className="navbar-brand" href="#">Comercial AC 2025, C.A.</a> */}
      <img src="logo-ac2025.png" alt="Comercial AC 2025, C.A." height={50} width={200} />
      <div className="collapse navbar-collapse">
        <ul className="navbar-nav ms-auto">
          <li className="nav-item"><a className="nav-link" href="#about">Nosotros</a></li>
          <li className="nav-item"><a className="nav-link" href="#categories">Productos</a></li>
          <li className="nav-item"><a className="nav-link" href="#contact">Contacto</a></li>
        </ul>
      </div>
    </nav>
  );
}

export default Header;